import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { FieldArray } from 'react-final-form-arrays';
import TextFieldComponent from './components/TextFieldComponent';
import SelectFieldComponent from './components/SelectFieldComponent';
import DateFieldComponent from './components/DateFieldComponent';
import FormFieldArray from './components/FormFieldArray';
import CheckboxFieldComponent from './components/CheckboxFieldComponent';
import ToggleButton from './components/ToggleButton';
import DrivedFieldComponent from './components/DrivedFieldComponent';
import TextAreaFieldComponent from './components/TextAreaFieldComponent';
import LocationFieldComponent from './components/LocationFieldComponent';
import FieldArrayComponent from './components/FieldArrayComponent';
import { HelpeContext } from '../../contexts';
import BarcodeField from './components/BarcodeField';
import LanguageFieldComponent from './components/LanguageFieldComponent';
import CustomTitleFieldComponent from './components/CustomTitleFieldComponent';
import InstanceFieldComponent from './components/InstanceFieldComponent';
import { requiredFieldArray } from '../../utils/utils';

export const fieldTypesComponents = {
  text: TextFieldComponent,
  textArea: TextAreaFieldComponent,
  select: SelectFieldComponent,
  date: DateFieldComponent,
  checkbox: CheckboxFieldComponent,
  fieldArray: FieldArrayComponent,
  toggleButton: ToggleButton,
  locationField: LocationFieldComponent,
  customTitle: CustomTitleFieldComponent,
  languageField: LanguageFieldComponent,
  barcodeField: BarcodeField,
  instanceField: InstanceFieldComponent,
};

const propTypes = {
  fieldValues: PropTypes.object,
  index: PropTypes.number,
  locale: PropTypes.string,
  formRenderProps: PropTypes.object,
  pageName: PropTypes.string,
  controlledVocab: PropTypes,
  actionType: PropTypes.string,
};

function FieldGenerator({
  fieldValues,
  index,
  locale,
  formRenderProps,
  pageName,
  controlledVocab,
  actionType,
}) {
  const { showHelpeIcon } = useContext(HelpeContext);

  const { isRepeatable, isRequired, type, fieldArray, drivedFields } =
    fieldValues;
  const FieldComponent = fieldTypesComponents[fieldValues.type];
  const fieldName = pageName
    ? `${pageName}.${fieldValues.name}`
    : fieldValues.name;

  if (drivedFields) {
    return <DrivedFieldComponent fieldValues={fieldValues} />;
  }

  if (type === 'fieldArray' && fieldArray && !drivedFields) {
    return (
      <>
        <FieldArrayComponent
          key={`form-fields-generator-fieldArray-${fieldValues.name}`}
          fieldValues={fieldValues}
          formRenderProps={formRenderProps}
          showHelpeIcon={showHelpeIcon}
          fieldName={fieldName}
          controlledVocab={controlledVocab}
          actionType={actionType}
        />
      </>
    );
  }

  if (isRepeatable && type !== 'fieldArray') {
    return (
      <>
        <FieldArray
          key={`form-fields-generator-isRepeatable-field-${fieldValues.name}`}
          name={fieldName}
          component={FormFieldArray}
          subscription={{ value: true }}
          RenderFieldComponent={FieldComponent}
          fieldValues={fieldValues}
          showHelpeIcon={showHelpeIcon}
          pageName={pageName}
          validate={isRequired ? requiredFieldArray : () => undefined}
          controlledVocab={controlledVocab}
          actionType={actionType}
          // parse={(value) => (value === undefined ? [] : value)} // Fix issue: Empty values don't appear in values
          parse={(value) => console.log({ value })}
        />
      </>
    );
  }

  return (
    <>
      <FieldComponent
        key={`form-fields-generator-single-field-${fieldValues.name}`}
        index={index}
        fieldValues={fieldValues}
        fieldName={fieldName}
        locale={locale}
        showHelpeIcon={showHelpeIcon}
        controlledVocab={controlledVocab}
        actionType={actionType}
      />
    </>
  );
}

FieldGenerator.propTypes = propTypes;

export default FieldGenerator;
